<template lang="html">
	<div class="omapi-pricing-tray">
		<div class="omapi-pricing">
			<wizard-pricing-tray-plan
				v-for="plan in plans"
				:key="plan.level"
				:plan="plan"
				@initCheckout="$emit('initCheckout', $event)"
			/>
		</div>
		<div class="omapi-pricing-tray__explore-more omapi-text-center">
			Don't see a plan that fits your needs? Explore the options at
			<a class="omapi-pricing-tray__link" :href="marketingUrl('pricing', 'OnboardingWizard')" target="_blank">
				optinmonster.com
			</a>
		</div>
		<div class="omapi-pricing-tray__disclaimer omapi-text-center">
			All pricing is in USD. Price above valid for first time purchases only. Renewals occur at normal price.
			<br />
			You can change plans or cancel your account at any time.
		</div>
	</div>
</template>

<script lang="js">
import { marketingSso } from '@/components/mixins/marketingSso'
import { mapActions, mapState } from 'vuex'

export default {
	mixins: [marketingSso],
	computed : {
		...mapState('wizard', [ 'pricing' ]),
		shouldFetchPricingData () {
			return !this.$store.getters.isFetching('pricing') && !this.$store.getters.isFetched('pricing')
		},
		plans () {
			return this.$get(`pricing.plans`, []);
		},
	},
	mounted () {
		if (this.shouldFetchPricingData) {
			this.fetchPricingGrid()
		}
	},
	methods : {
		...mapActions('wizard', [ 'fetchPricingGrid' ]),
	}
};
</script>

<style lang="scss">
.omapi-pricing-tray {
	.omapi-pricing {
		margin: 58px 0 16px 0;

		// Use Grid and make sure all columns auto-fit to the same width.
		// This allows us providing more/less plans in the api response.
		display: grid;
		grid-auto-flow: column;
		grid-auto-columns: 1fr;

		.omapi-plan {
			display: flex;
			padding: 20px 19px;
			flex-direction: column;

			gap: 24px;
			flex-shrink: 0;
			border: 1px solid #9ecdf2;
			background: #fff;
			box-shadow: 0px -4px 0px 0px rgba(5, 52, 89, 0.06) inset, 0px 4px 20px -4px rgba(7, 86, 148, 0.1);

			&.level-free {
				border-radius: 10px 0px 0px 10px;
			}

			&.level-pro {
				background: #f8fbfe;
				position: relative;
			}

			&.level-growth {
				border-radius: 0px 10px 10px 0px;
			}

			&__popular {
				width: 100%;
				height: 40px;
				color: #fff;
				background: #0d82df;
				border-color: #0d82df;
				border-style: solid;
				border-width: 1px 1px 0 1px;
				border-radius: 10px 10px 0 0;
				text-align: center;
				font-size: 15px;
				font-weight: 400;
				line-height: 40px;
				position: absolute;
				top: -42px;
				right: -1px;
			}

			&__title {
				color: #122140;
				font-size: 24px;
				font-weight: 700;
				line-height: 150%;
			}

			&__description {
				color: #596479;
				font-size: 16px;
				font-weight: 400;
				line-height: 150%;
			}

			&__header {
				align-items: center;
				text-align: center;
			}

			&__content {
				align-items: flex-start;
				margin-bottom: 24px;
			}

			&__pricing {
				display: flex;
				flex-direction: column;
				gap: 12px;

				&-regular {
					color: #717a8c;
					font-size: 16px;
					font-weight: 400;
					line-height: 160%;
					text-decoration: line-through;
				}

				&-offer {
					color: #122140;
					font-size: 30px;
					font-weight: 400;
					line-height: 100%;
					letter-spacing: -0.45px;
				}

				&-currency {
					font-size: 18px;
					vertical-align: super;
					letter-spacing: -0.27px;
				}

				&-billing-period {
					color: #717abc;
					font-size: 16px;
					line-height: 100%;
				}

				&-notation {
					color: #717a8c;
					font-size: 14px;
					line-height: 150%;
				}
			}

			&__action-btn-container {
				padding: 24px 0;
				border-bottom: 1px solid #e7e9ec;

				.omapi-button {
					font-size: 18px;
					width: 100%;
					padding: 15px 0;
				}
			}

			&__features {
				font-size: 16px;
				color: #596479;

				&-heading {
					font-size: 16px;
					font-weight: 700;
					height: 34px;
					line-height: 160%;
					margin-bottom: 8px;
				}

				&-type {
					font-weight: 700;
				}

				ul {
					list-style-type: disc;

					li {
						font-weight: 400;
						margin-left: 22px;
						line-height: 130%;
					}
				}
			}
		}
	}

	&__explore-more {
		color: #646970;
		font-size: 16px;
		font-weight: 700;
		line-height: 150%;
		margin-top: 48px;
	}

	&__link {
		margin-top: 20px;
		font-size: 15px;
		line-height: 160%;
		text-decoration: underline;
	}

	&__disclaimer {
		color: #60656f;
		font-size: 12px;
		font-weight: 400;
		line-height: 150%;
	}
}
</style>
